import { Header } from '@/components/Layout/Header/Header';
import { EstablishmentsList } from '@/components/Views/Establishments';
import EstablishmentStatistics from '@/components/Views/Establishments/EstablishmentStat';

export const Establishments = () => {
  return (
    <>
      <Header title="Etablissements" goBack />
      <EstablishmentStatistics />
      <EstablishmentsList />
    </>
  );
};
